export const actionConst = {
  COUNT_PENDING: 'EXPIRED_REQUESTS_COUNT_PENDING',
  COUNT_FULFILLED: 'EXPIRED_REQUESTS_COUNT_FULFILLED',
  COUNT_REJECTED: 'EXPIRED_REQUESTS_COUNT_REJECTED',
};
